define('signupModal',['jquery'],
    function ($) {

        var signupmodal = $(".signup-modal"),
            modalbig = $(".signup-modal.big"),
            modalsmall = $(".signup-modal.small"),
            closeModalBig = modalbig.find(".close"),
            editBtn = signupmodal.find(".edit"),
            signupBtn = signupmodal.find(".signup"),
            signupForm = $(".signup-form"),
            emailField = $(".signup-form .email-field"),
            nameField = $(".signup-form .name-field");
            //consentCheckbox = $(".signup-form .consent-checkbox");
        function initModal() {
            modalsmall.addClass("modal-visible");
        }

        function openModalBigEvent() {
            modalsmall.on("click", function (e) {
                e.preventDefault();

                // Make sure form is reset when opening
                signupBtn.removeClass("hidden");
                editBtn.removeClass("hidden");
                signupForm[0].reset();
                $(".status-txt").addClass("hidden").empty();

                var $this = $(this);
                $this.addClass("modal-hidden").removeClass("modal-visible");
                modalbig.addClass("modal-visible").removeClass("modal-hidden");
            });
        }

        function closeModalBigEvent() {
            closeModalBig.on("click", function (e) {
                e.preventDefault();

                var $this = $(this);
                $this.closest(".signup-modal").addClass("modal-hidden");
                modalsmall.addClass("modal-visible").removeClass("modal-hidden");
            });
        }

        function checkForEmail(e) {

            function callEmailService(type, email, name) {
                $.ajax({
                    type: "GET",
                    url: "/api/emailplatform/Index?email=" + email + "&type=" + type + "&name=" + name,
                    async: false,
                    beforeSend: function (x) {
                        if (x && x.overrideMimeType) {
                            x.overrideMimeType("application/j-son;charset=UTF-8");
                        }
                    },
                    dataType: "json",
                    success: function (data) {

                        if (type === "signup") {
                            if (data.isSubscribed === true) {
                                // you exists already
                                $(".status-txt").removeClass("hidden").append("<p class='color-red'>Du er allerede tilmeldt vores nyhedsbrev. <br/><button class='signup-btn-edit signup' type='submit'>Tilpas nyhedbrev</button></p>");
                                signupBtn.addClass("hidden");
                            } else {
                                //you do not exist. Redirect to signup page
                                signupForm.submit();
                            }
                        }
                        if (type === "edit") {
                            if (data.isSubscribed === true) {
                                // you exists already
                                $(".status-txt").removeClass("hidden").append("<p class='color-green'>Vi har sendt et link til " + "<strong>" + email + "</strong>" + ", så du kan redigere dine tilmeldinger.</p>");
                                signupBtn.addClass("hidden");
                                editBtn.addClass("hidden");
                            } else {
                                //you do not exist. Redirect to signup page
                                $(".status-txt").removeClass("hidden").append("<p class='color-red'>Du er ikke tilmeldt vores nyhedsbrev. Du kan trykke på knappen <strong>Tilmeld nyhedsbrev</strong>.</p>");
                                editBtn.addClass("hidden");
                            }
                        }

                    }
                });
            }

            //Regex function for email
            function testEmail(emailVal) {
                //var emailReg = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i),
                var emailReg = new RegExp(/^(("[\w+\-\s]+")|([\w+\-]+(?:\.[\w+\-]+)*)|("[\w+\-\s]+")([\w+\-]+(?:\.[\w+\-]+)*))(@((?:[\w\-]+\.)*\w[\w\-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

                valid = emailReg.test(emailVal);
                    
                if (!valid) {
                    return false;
                } else {
                    return true;
                }
            }

            //signup click event
            signupBtn.on("click", function (e) {
                e.preventDefault();
                var type = "signup";

                validate(type);
            });

            //edit signup event
            editBtn.on("click", function (e) {
                e.preventDefault();
                var type = "edit";

                validate(type);
            });

            //consentCheckbox.on("change", function (e) {
            //    consentCheckbox.removeClass("error");
            //});

            function validate(type) {
                var emailVal = emailField.val();
                var nameVal = nameField.val();
                //var checkboxVal = consentCheckbox[0].checked;

                if (!emailVal.length > 0) {
                    emailField.addClass("error-email");
                    return;
                }
                if (!nameVal.length > 0) {
                    nameField.addClass("error-email");
                    return;
                }
                //if (!checkboxVal) {
                //    consentCheckbox.addClass("error");
                //    return;
                //}
                // validate email
                if (testEmail(emailVal) === true) {
                    emailField.removeClass("error-email");

                    //call service to check if email exists or not
                    callEmailService(type, emailVal, nameVal);
                } else {
                    emailField.addClass("error-email");
                }
            }

        }


        initModal();
        openModalBigEvent();
        closeModalBigEvent();
        checkForEmail();

    }

);

